import React from 'react';
import './olon.css';



const Olon = () => {
    return (
        <main> 
            <h1>Олон нийттэй харилцах алба</h1>
        </main>
    )
}
export default Olon;